export const FeedbacksWrapper = {
  padding: { xs: '0px 4px', sm: '0px 30px', md: '0px 100px' },
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '24px', sm: '30px' },
}
